import React from "react";

const LeadsActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="36"
      viewBox="0 0 30 36"
      fill="none"
    >
      <path
        d="M28.1096 15.5891H17.1507C17.1507 10.3288 20.9498 9.7443 22.8493 9.89042C27.4082 9.89042 28.2557 13.5434 28.1096 15.5891Z"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.5205H13.3973"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5342 18.6575L16.4658 21.726V28.3014L10.7671 34V21.726L2 12.9589V8.57535H16.0274"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="22.8493"
        cy="5.06849"
        r="3.06849"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeadsActiveIcon;
